

// import React, { useRef, useState, useEffect } from "react";
// import Slider from "react-slick";
// import { FaTrashAlt } from "react-icons/fa";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// const GalleryCards = () => {
//     const [images, setImages] = useState([]);
//     const [aboutUsId, setAboutUsId] = useState(null);
//     const [vendorId, setVendorId] = useState(null);
//     const fileInputRef = useRef(null);

//     // Get vendorId on mount
//     useEffect(() => {
//         const storedVendorId = localStorage.getItem("vendorId");
//         setVendorId(storedVendorId);
//     }, []);

//     // Fetch existing About Us images
//     useEffect(() => {
//         if (vendorId) fetchAboutUsData(vendorId);
//     }, [vendorId]);

//     const fetchAboutUsData = async (vId) => {
//         const token = localStorage.getItem("authToken");
//         if (!token) return alert("Authorization token missing.");

//         try {
//             const response = await fetch(
//                 `https://backend.maamaas.com/food/api/vendor/aboutus/get/${vId}`,
//                 { headers: { Authorization: `Bearer ${token}` } }
//             );
//             if (!response.ok) return;

//             const data = await response.json();
//             const galleryData = Array.isArray(data) ? data[0] : data;
//             setAboutUsId(galleryData.aboutUsId || null);

//             // Map backend image URLs
//             const backendImages = [];
//             ["image", "image1", "image2", "image3", "image4"].forEach((field) => {
//                 if (galleryData[field]) {
//                     backendImages.push({
//                         id: field,
//                         src: galleryData[field],
//                         isNew: false,
//                     });
//                 }
//             });

//             setImages(backendImages); // ✅ Show gallery from backend URLs
//         } catch (err) {
//             console.error("Error fetching About Us:", err);
//         }
//     };


//     const settings = {
//         dots: false,
//         infinite: images.length > 2,
//         speed: 500,
//         slidesToShow: Math.min(images.length, 3),
//         slidesToScroll: 1,
//         autoplay: images.length > 0,
//         autoplaySpeed: 2000,
//         pauseOnHover: true,
//         responsive: [
//             { breakpoint: 1024, settings: { slidesToShow: Math.min(images.length, 2), infinite: images.length > 1 } },
//             { breakpoint: 768, settings: { slidesToShow: Math.min(images.length, 1), infinite: images.length > 0 } },
//         ],
//     };

//     const handleAddImageClick = () => {
//         if (!vendorId) return alert("User not identified. Please log in.");
//         if (images.length >= 4) return alert("Maximum 4 images allowed.");
//         fileInputRef.current.click();
//     };

//     const handleFileChange = async (event) => {
//         if (!aboutUsId || !vendorId) return;
//         const files = Array.from(event.target.files);
//         const newImages = files.map(file => ({ file, isNew: true, src: URL.createObjectURL(file) }));
//         const updatedImages = [...images, ...newImages];
//         if (updatedImages.length > 4) {
//             alert("Maximum 4 images allowed.");
//             return;
//         }
//         setImages(updatedImages);

//         // Send images as multipart/form-data
//         await sendImagesToAPI(updatedImages);
//     };

//     const sendImagesToAPI = async (currentImagesArray) => {
//         const token = localStorage.getItem("authToken");
//         if (!token) return alert("Authorization token missing.");
//         if (!aboutUsId) return alert("About Us ID missing.");

//         try {
//             const formData = new FormData();

//             // Add the aboutUsData as JSON blob
//             const aboutUsBlob = new Blob([JSON.stringify({ aboutUsId })], { type: "application/json" });
//             formData.append("aboutUsData", aboutUsBlob);

//             // Append images
//             currentImagesArray.forEach((img, index) => {
//                 if (img.file) formData.append(`image${index + 1}`, img.file);
//             });

//             const response = await fetch(
//                 `https://backend.maamaas.com/food/api/vendor/aboutus/update/${aboutUsId}`,
//                 {
//                     method: "PUT",
//                     headers: { Authorization: `Bearer ${token}` },
//                     body: formData,
//                 }
//             );

//             // console.log("HTTP status:", response.status);
//             const responseText = await response.text();
//             // console.log("Response body:", responseText);

//             if (!response.ok) {
//                 alert(`Update failed with status ${response.status}. Check console for details.`);
//                 return;
//             }

//             // Refresh gallery after successful upload
//             fetchAboutUsData(vendorId);
//             alert("Images updated successfully!");
//         } catch (err) {
//             console.error("Error while updating:", err);
//             alert("Error while updating. Check console for details.");
//         }
//     };

//     const handleDelete = (index) => {
//         const updatedImages = images.filter((_, i) => i !== index);
//         setImages(updatedImages);
//         if (aboutUsId && vendorId) sendImagesToAPI(updatedImages);
//     };

//     const ImageCard = ({ src, index }) => (
//         <div className="image-card-container">
//             <img src={src} alt={`gallery-item-${index}`} className="gallery-image" />
//             <button onClick={(e) => { e.stopPropagation(); handleDelete(index); }} className="delete-button">
//                 <FaTrashAlt size={14} color="red" />
//             </button>
//         </div>
//     );

//     return (
//         <section className="gallery-section">
//             <div className="gallery-header">
//                 <h1 className="gallery-title">
//                     <span className="title-red">Gall</span>
//                     <span className="title-black">ery</span>
//                 </h1>

//                 <button onClick={handleAddImageClick} disabled={images.length >= 4 || !vendorId} className="add-button">
//                     Add+
//                 </button>
//                 <input
//                     ref={fileInputRef}
//                     type="file"
//                     accept="image/*"
//                     onChange={handleFileChange}
//                     className="file-input"
//                     multiple
//                 />
//             </div>

//             {images.length > 0 ? (
//                 <Slider key={images.length} {...settings}>
//                     {images.map((img, idx) => (
//                         <div key={idx} className="slider-item">
//                             <ImageCard src={img.src} index={idx} />
//                         </div>
//                     ))}
//                 </Slider>
//             ) : (
//                 <p className="empty-message">No gallery images uploaded yet. Click "Add+" to upload.</p>
//             )}

//             <style jsx>{`
//                 .gallery-section { width: 100%; max-width: 1200px; margin: 0 auto; padding: 20px 15px; }
//                 .gallery-header { display: flex; align-items: center; margin-bottom: 20px; justify-content: center; flex-wrap: wrap; gap: 15px; }
//                 .gallery-title { font-size: 38px; font-weight: bold; letter-spacing: 1px; text-transform: uppercase; text-shadow: 0 4px 6px rgba(0,0,0,0.1); margin: 0; text-align: center; }
//                 .title-red { color: red; }
//                 .title-black { color: black; }
//                 .add-button { height: 35px; border-radius: 5px; border: none; background: #b15cd6; color: #fff; font-weight: bold; cursor: pointer; width: 80px; transition: all 0.3s ease; }
//                 .add-button:disabled { background: #ccc; cursor: not-allowed; }
//                 .file-input { display: none; }
//                 .image-card-container { position: relative; width: 100%; height: 300px; overflow: hidden; border-radius: 16px; margin: 0 10px; }
//                 .gallery-image { width: 100%; height: 100%; object-fit: cover; }
//                 .delete-button { position: absolute; top: 10px; right: 10px; background: rgba(0,0,0,0.6); border: none; border-radius: 50%; padding: 6px; color: white; cursor: pointer; display: flex; align-items: center; justify-content: center; z-index: 2; }
//                 .empty-message { text-align: center; color: #777; font-style: italic; padding: 20px; }
//             `}</style>
//         </section>
//     );
// };

// export default GalleryCards;




import React, { useRef, useState, useEffect } from "react";
import { FaTrashAlt, FaEdit, FaUpload, FaTimes } from "react-icons/fa";

const GalleryCards = () => {
    const [images, setImages] = useState([]);
    const [aboutUsId, setAboutUsId] = useState(null);
    const [vendorId, setVendorId] = useState(null);
    const [editingIndex, setEditingIndex] = useState(null);
    const [loading, setLoading] = useState(false);
    const fileInputRef = useRef(null);

    // Get vendorId on mount
    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        setVendorId(storedVendorId);
    }, []);

    // Fetch existing About Us images
    useEffect(() => {
        if (vendorId) fetchAboutUsData(vendorId);
    }, [vendorId]);

    const fetchAboutUsData = async (vId) => {
        const token = localStorage.getItem("authToken");
        if (!token) return;

        try {
            setLoading(true);
            const response = await fetch(
                `https://backend.maamaas.com/food/api/vendor/aboutus/get/${vId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (!response.ok) {
                setLoading(false);
                return;
            }

            const data = await response.json();
            const galleryData = Array.isArray(data) ? data[0] : data;
            setAboutUsId(galleryData.aboutUsId || null);

            // ONLY process image1, image2, image3, image4 (skip 'image' field)
            const imageFields = ["image1", "image2", "image3", "image4"];
            const fetchedImages = [];

            imageFields.forEach((field, index) => {
                if (galleryData[field]) {
                    fetchedImages.push({
                        id: index,
                        src: galleryData[field],
                        fieldName: field,
                        isNew: false,
                    });
                }
            });

            // Fill remaining slots as empty (max 4 slots)
            const emptySlots = 4 - fetchedImages.length;
            for (let i = 0; i < emptySlots; i++) {
                fetchedImages.push({
                    id: fetchedImages.length + i,
                    src: null,
                    fieldName: `image${fetchedImages.length + i + 1}`,
                    isNew: false,
                });
            }

            setImages(fetchedImages);
        } catch (err) {
            console.error("Error fetching gallery:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleAddImageClick = (index = null) => {
        if (!vendorId) {
            alert("Please log in to upload images.");
            return;
        }

        if (index !== null) {
            setEditingIndex(index);
        }

        fileInputRef.current.click();
    };

    const handleFileChange = async (event) => {
        if (!vendorId) {
            alert("Please log in first.");
            return;
        }

        const file = event.target.files[0];
        if (!file) return;

        // Validate file type
        if (!file.type.startsWith('image/')) {
            alert("Please upload an image file.");
            return;
        }

        // Validate file size (max 5MB)
        if (file.size > 5 * 1024 * 1024) {
            alert("Image size should be less than 5MB.");
            return;
        }

        const targetIndex = editingIndex !== null ? editingIndex : images.findIndex(img => img.src === null);

        if (targetIndex === -1) {
            alert("All gallery slots are filled. Please delete an image first.");
            return;
        }

        // Create temporary URL for preview
        const tempUrl = URL.createObjectURL(file);
        const updatedImages = [...images];
        updatedImages[targetIndex] = {
            ...updatedImages[targetIndex],
            src: tempUrl,
            file: file,
            isNew: true,
        };

        setImages(updatedImages);
        await sendImageToAPI(file, targetIndex);
        setEditingIndex(null);

        // Reset file input
        event.target.value = '';
    };

    const sendImageToAPI = async (file, index) => {
        const token = localStorage.getItem("authToken");
        if (!token) {
            alert("Authorization token missing.");
            return;
        }

        try {
            setLoading(true);
            const formData = new FormData();

            // If aboutUsId exists, update; otherwise create new
            const aboutUsData = aboutUsId ? { aboutUsId } : { vendorId };
            const aboutUsBlob = new Blob([JSON.stringify(aboutUsData)], { type: "application/json" });
            formData.append("aboutUsData", aboutUsBlob);

            // Append the image with correct field name (image1, image2, etc.)
            formData.append(`image${index + 1}`, file);

            const endpoint = aboutUsId ? "update" : "create";
            const url = `https://backend.maamaas.com/food/api/vendor/aboutus/${endpoint}`;

            if (aboutUsId) {
                url += `/${aboutUsId}`;
            }

            const response = await fetch(url, {
                method: aboutUsId ? "PUT" : "POST",
                headers: { Authorization: `Bearer ${token}` },
                body: formData,
            });

            if (!response.ok) {
                throw new Error(`Failed to upload image: ${response.status}`);
            }

            const result = await response.json();
            setAboutUsId(result.aboutUsId || aboutUsId);

            // Refresh gallery to get permanent URLs
            fetchAboutUsData(vendorId);

            alert("Image uploaded successfully!");
        } catch (error) {
            console.error("Upload error:", error);
            alert("Failed to upload image. Please try again.");

            // Revert on error
            const revertedImages = [...images];
            revertedImages[index] = {
                ...revertedImages[index],
                src: null,
                file: null,
                isNew: false,
            };
            setImages(revertedImages);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (index) => {
        if (!window.confirm("Are you sure you want to delete this image?")) return;

        if (!vendorId || !aboutUsId) {
            alert("Cannot delete image. Please try again later.");
            return;
        }

        try {
            setLoading(true);
            const token = localStorage.getItem("authToken");

            // Create form data with null image for the specific field
            const formData = new FormData();
            const aboutUsBlob = new Blob([JSON.stringify({ aboutUsId })], { type: "application/json" });
            formData.append("aboutUsData", aboutUsBlob);

            // Send empty file to clear the image
            formData.append(`image${index + 1}`, new Blob([]), '');

            const response = await fetch(
                `https://backend.maamaas.com/food/api/vendor/aboutus/update/${aboutUsId}`,
                {
                    method: "PUT",
                    headers: { Authorization: `Bearer ${token}` },
                    body: formData,
                }
            );

            if (!response.ok) {
                throw new Error(`Failed to delete image: ${response.status}`);
            }

            // Update local state
            const updatedImages = [...images];
            updatedImages[index] = {
                ...updatedImages[index],
                src: null,
                file: null,
                isNew: false,
            };

            setImages(updatedImages);
            alert("Image deleted successfully!");
        } catch (error) {
            console.error("Delete error:", error);
            alert("Failed to delete image. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const GalleryImage = ({ image, index }) => {
        if (image.src) {
            return (
                <div className="gallery-image-card">
                    <div className="image-container">
                        <img
                            src={image.src}
                            alt={`Gallery ${index + 1}`}
                            className="gallery-image"
                            onError={(e) => {
                                e.target.src = "https://via.placeholder.com/300x200?text=Image+Error";
                            }}
                        />
                        <div className="image-overlay">
                            <button
                                className="action-btn edit-btn"
                                onClick={() => handleAddImageClick(index)}
                                title="Replace image"
                            >
                                <FaEdit size={16} />
                            </button>
                            <button
                                className="action-btn delete-btn"
                                onClick={() => handleDelete(index)}
                                title="Delete image"
                            >
                                <FaTrashAlt size={16} />
                            </button>
                        </div>
                    </div>

                </div>
            );
        }

        return (
            <div className="empty-image-card">
                <div className="empty-image-container">
                    <FaUpload size={40} color="#b15cd6" />
                    <p className="empty-text">Empty Slot</p>
                    <button
                        className="add-image-btn"
                        onClick={() => handleAddImageClick(index)}
                    >
                        Add Image
                    </button>
                </div>
                <div className="image-info">
                    <span className="image-label">Image {index + 1}</span>
                    <span className="image-status">Empty</span>
                </div>
            </div>
        );
    };

    return (
        <div className="gallery-container">


            {loading ? (
                <div className="loading-container">
                    <div className="spinner"></div>
                    <p>Loading gallery...</p>
                </div>
            ) : (
                <div className="gallery-grid">
                    {images.slice(0, 4).map((image, index) => (
                        <GalleryImage key={image.id || index} image={image} index={index} />
                    ))}
                </div>
            )}



            <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                className="file-input-hidden"
            />

            <style jsx>{`
                .gallery-container {
                    width: 100%;
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 24px 16px;
                    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
                }

                .gallery-header {
                    display: flex;
                    flex-direction: column;
                    gap: 24px;
                    margin-bottom: 32px;
                    padding-bottom: 24px;
                    border-bottom: 1px solid #eaeaea;
                }

                @media (min-width: 768px) {
                    .gallery-header {
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: flex-start;
                    }
                }

                .header-content {
                    flex: 1;
                }

                .gallery-title {
                    font-size: 32px;
                    font-weight: 700;
                    margin: 0 0 8px 0;
                    color: #1a1a1a;
                }

                .title-highlight {
                    color: #b15cd6;
                    background: linear-gradient(135deg, #b15cd6 0%, #9a4bc2 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                }

                .gallery-subtitle {
                    font-size: 16px;
                    color: #666;
                    margin: 0;
                    line-height: 1.5;
                }

                .header-stats {
                    display: flex;
                    gap: 16px;
                }

                .stat-card {
                    background: linear-gradient(135deg, #f8f4ff 0%, #f0e6f5 100%);
                    padding: 16px 24px;
                    border-radius: 12px;
                    border: 1px solid #e6d6f0;
                    text-align: center;
                    min-width: 140px;
                }

                .stat-number {
                    display: block;
                    font-size: 28px;
                    font-weight: 700;
                    color: #b15cd6;
                    margin-bottom: 4px;
                }

                .stat-label {
                    font-size: 14px;
                    color: #666;
                    font-weight: 500;
                }

                .gallery-grid {
                    display: grid;
                    grid-template-columns: repeat(1, 1fr);
                    gap: 24px;
                    margin-bottom: 40px;
                }

                @media (min-width: 640px) {
                    .gallery-grid {
                        grid-template-columns: repeat(2, 1fr);
                    }
                }

                @media (min-width: 1024px) {
                    .gallery-grid {
                        grid-template-columns: repeat(4, 1fr);
                    }
                }

                .gallery-image-card, .empty-image-card {
                    background: white;
                    border-radius: 16px;
                    overflow: hidden;
                    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
                    transition: all 0.3s ease;
                    border: 1px solid #eaeaea;
                }

                .gallery-image-card:hover {
                    transform: translateY(-4px);
                    box-shadow: 0 8px 30px rgba(177, 92, 214, 0.15);
                }

                .image-container {
                    position: relative;
                    width: 100%;
                    height: 200px;
                    overflow: hidden;
                    background: #f8f8f8;
                }

                .gallery-image {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: transform 0.3s ease;
                }

                .gallery-image-card:hover .gallery-image {
                    transform: scale(1.05);
                }

                .image-overlay {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: rgba(0, 0, 0, 0.5);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 16px;
                    opacity: 0;
                    transition: opacity 0.3s ease;
                }

                .gallery-image-card:hover .image-overlay {
                    opacity: 1;
                }

                .action-btn {
                    width: 44px;
                    height: 44px;
                    border-radius: 50%;
                    border: none;
                    background: rgba(255, 255, 255, 0.95);
                    color: #333;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.2s ease;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
                }

                .action-btn:hover {
                    transform: scale(1.1);
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
                }

                .edit-btn:hover {
                    color: #b15cd6;
                }

                .delete-btn:hover {
                    color: #ff4757;
                }

                .empty-image-container {
                    width: 100%;
                    height: 200px;
                    background: linear-gradient(135deg, #f8f4ff 0%, #f0e6f5 100%);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    padding: 24px;
                    border-bottom: 1px solid #eaeaea;
                }

                .empty-text {
                    margin: 12px 0;
                    color: #666;
                    font-size: 14px;
                    font-weight: 500;
                }

                .add-image-btn {
                    background: #b15cd6;
                    color: white;
                    border: none;
                    padding: 8px 16px;
                    border-radius: 8px;
                    font-size: 14px;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.2s ease;
                }

                .add-image-btn:hover {
                    background: #9a4bc2;
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(177, 92, 214, 0.3);
                }

                .image-info {
                    padding: 16px;
                    background: white;
                }

                .image-label {
                    display: block;
                    font-size: 14px;
                    font-weight: 600;
                    color: #333;
                    margin-bottom: 4px;
                }

                .image-status {
                    display: block;
                    font-size: 12px;
                    color: #666;
                }

                .gallery-instructions {
                    margin-top: 40px;
                    padding: 24px;
                    background: linear-gradient(135deg, #f8f4ff 0%, #f0e6f5 100%);
                    border-radius: 16px;
                    border: 1px solid #e6d6f0;
                }

                .instruction-card h3 {
                    margin: 0 0 16px 0;
                    color: #333;
                    font-size: 18px;
                    font-weight: 600;
                }

                .instruction-card ul {
                    margin: 0;
                    padding-left: 20px;
                    color: #666;
                    line-height: 1.6;
                }

                .instruction-card li {
                    margin-bottom: 8px;
                }

                .loading-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    padding: 60px 20px;
                }

                .spinner {
                    width: 40px;
                    height: 40px;
                    border: 3px solid #f0e6f5;
                    border-top: 3px solid #b15cd6;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                    margin-bottom: 16px;
                }

                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }

                .file-input-hidden {
                    display: none;
                }

                /* Responsive adjustments */
                @media (max-width: 640px) {
                    .gallery-title {
                        font-size: 24px;
                    }
                    
                    .header-stats {
                        flex-direction: column;
                    }
                    
                    .stat-card {
                        min-width: auto;
                    }
                    
                    .gallery-grid {
                        gap: 16px;
                    }
                    
                    .image-container {
                        height: 160px;
                    }
                    
                    .empty-image-container {
                        height: 160px;
                    }
                }
            `}</style>
        </div>
    );
};

export default GalleryCards;